// @flow
'use strict';

var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/gud/index.js
// module id = 937
// module chunks = 2 3 4 5 6 9 13